import React, { useRef, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import useAxios from '../../../../network/useAxios';
import NavData from '../../../../config/data/nav/nav_data.json';
import { programCornerList } from '../../../../network/apis/apiUri';
import { NEWS_SCHEDULE } from '../../../../reducer';

import './css/NewsDailyFocusModal.scss';

function NewsDailyFocusModal() {
  const [modalToggle, setModalToggle] = useState(false);
  const modalEl = useRef();

  const dispatch = useDispatch();
  const { news, mode } = useSelector((state) => state);
  const history = useHistory();
  const location = useLocation();
  const [cornerSort, setCornerSort] = useState();

  const [cornerItem] = useAxios(
    programCornerList,
    [],
    { lan_code: 'en', program_type: 'tv', news_allow: true, is_open_allow: true },
    true
  );

  const { data: cornerData } = cornerItem;

  const progremPage = (v) => {
    dispatch({ type: NEWS_SCHEDULE, schedule: v.title });
    history.push({ pathname: NavData['NEWS_CORNER'].path, state: v.corner_id });
    setModalToggle(false);
  };

  const handleClickOutside = ({ target }) => {
    if (modalToggle || !modalEl.current?.contains(target)) {
      setModalToggle(false);
    }
  };

  useEffect(() => {
    setModalToggle(false);
  }, [history.location.pathname]);

  useEffect(() => {
    if (cornerData) {
      const arr = cornerData.item.pop();
      setCornerSort([arr, ...cornerData.item]);
    }
  }, [cornerData]);

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <section id="NewsDailyFocusModal" className="newsDailyFocusModal" ref={modalEl}>
      <button
        className={`btnList ${modalToggle && 'on'} ${
          location.pathname.split('/')[1] === 'news' && location.pathname.split('/')[2] === 'corner' && 'active'
        }`}
        type="button"
        title={
          modalToggle
            ? mode === 'en'
              ? 'Folding the Menu'
              : '메뉴 접기'
            : mode === 'en'
            ? 'Spread the Menu'
            : '메뉴 펼치기'
        }
        onClick={() => setModalToggle(!modalToggle)}
      >
        Daily Focus
      </button>
      {modalToggle ? (
        <div className="listModal" tabIndex={1}>
          <div className="listModal_list">
            {cornerSort &&
              cornerSort.map((v) => (
                <div className="listModal_list_data" key={`dailyModal_${v.corner_id}`}>
                  <button type="button" className="link" onClick={() => progremPage(v)}>
                    <span className={`link_text${news.schedule === v.title ? ' on' : ''}`}>{v.title}</span>
                  </button>
                </div>
              ))}
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default NewsDailyFocusModal;
